import { isDevelopment } from '@quicktools/shared-components';
import { BrazeService } from '@quicktools/shared-components/services/braze';

import { TOOL_NAME } from '../../configs';

export default new BrazeService(TOOL_NAME, { baseUrl: 'sdk.iad-01.braze.com' }, isDevelopment());
